import { OrderQuantitySelector } from "./OrderQuantitySelector";
import type { ShippingAddress } from "@stripe/stripe-js";
import { Elements, AddressElement } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

interface Product {
  _id: string;
  name?: string;
  price: number;
}

interface CheckoutShippingStepProps {
  products: Product[];
  quantities: Record<string, number>;
  onQuantityChange: (productId: string, quantity: number) => void;
  shippingAddress: ShippingAddress | null;
  onShippingAddressChange: (address: ShippingAddress | null) => void;
  onAddressCompleteChange: (complete: boolean) => void;
  stripePromise: ReturnType<typeof loadStripe> | null;
  total: number;
}

export function CheckoutShippingStep({
  products,
  quantities,
  onQuantityChange,
  shippingAddress,
  onShippingAddressChange,
  onAddressCompleteChange,
  stripePromise,
  total,
}: CheckoutShippingStepProps) {
  const getAddressDefaultValues = () => {
    if (!shippingAddress) return undefined;
    return {
      name: shippingAddress.name || "",
      address: {
        line1: shippingAddress.line1 || "",
        line2: shippingAddress.line2 || "",
        city: shippingAddress.city || "",
        state: shippingAddress.state || "",
        postal_code: shippingAddress.postal_code || "",
        country: shippingAddress.country || "US",
      },
    };
  };

  return (
    <div className="space-y-4 flex-1">
      <OrderQuantitySelector
        products={products}
        quantities={quantities}
        onQuantityChange={onQuantityChange}
        total={total}
      />

      <div className="space-y-4">
        {stripePromise && (
          <Elements
            stripe={stripePromise}
            key={`address-element-${shippingAddress ? "has-address" : "no-address"}`}
          >
            <AddressElement
              options={{
                mode: "shipping",
                fields: {
                  phone: "always",
                },
                validation: {
                  phone: {
                    required: "never",
                  },
                },
                defaultValues: getAddressDefaultValues(),
              }}
              onChange={(event) => {
                if (event.complete) {
                  const address = event.value.address as unknown as ShippingAddress;
                  if (event.value.name) {
                    address.name = event.value.name;
                  }
                  onShippingAddressChange(address);
                  onAddressCompleteChange(true);
                } else {
                  onAddressCompleteChange(false);
                }
              }}
            />
          </Elements>
        )}
      </div>
    </div>
  );
}
